import { createContext, useContext } from 'react'
import type { ResolvedTheme } from './themePreference'

/**
 * The theme of the surface a component is drawn on, for things CSS cannot
 * restyle: chart strokes and fills, third-party widgets. Layout provides the
 * user's resolved choice; PublicShell and anything outside both stay dark, so
 * a public page's charts never follow a signed-in visitor's preference.
 */
const SurfaceThemeContext = createContext<ResolvedTheme>('dark')

export const SurfaceThemeProvider = SurfaceThemeContext.Provider

export const useSurfaceTheme = (): ResolvedTheme => useContext(SurfaceThemeContext)
